module.exports = __webpack_public_path__ + "static/media/logo-signin-blue.753f7335.png";